<template>
  
  <v-menu
    ref="menu1"
    v-model="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
  
    <template v-slot:activator="{ on }">
      <v-text-field 
        v-model="computedDateFormatted"
        :rules="rules"
        :label="label"
        required
        readonly
        @blur="date = parseDate(dateFormatted)"
        v-on="on"
      ></v-text-field>
    </template>  
    
    <v-date-picker 
      v-model="date"
      :value="date"
      :max="max"
      locale="es-ES"
      first-day-of-week="1"
      color="primary"
      @input="changeValue"
    ></v-date-picker>

  </v-menu>

</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    
    label: {
      type: String,
      required: true
    },
    
    rules: {
      type: Array,
      required: true
    },

    value: {
      type: String,
      required: true
    },

    max: {
      type: String,
      default: () => {''}
    }

  },
  
  data: (v) => {
    return {
      menu1: false,
      date: new Date(v.value).toISOString().substr(0, 10),
      dateFormatted: v.formatDate(new Date(v.value).toISOString().substr(0, 10))
    }
  },

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
  },

  watch: {
    
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },

  },

  methods: {
   
    formatDate (date) {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    parseDate (date) {
      if (!date) {
        return null
      }

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    changeValue(value) {
      this.menu1 = false
      this.$emit('input', value)
    }

  }
}
</script>